import { Injectable } from '@angular/core';
import {RoundOfQuestionsSearch} from '../models/round-of-questions-search.interface';
import {PageRequest} from '../../shared/models/page-request.interface';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {environment} from '../../../environments/environment';
import {RoundOfQuestionsDetail} from '../models/round-of-questions-detail.interface';
import {RoundOfQuestions} from '../models/round-of-questions.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';

const ROUND_OF_QUESTIONS_API = environment.apiUrl + 'intelligencereporting/roundofquestions';

@Injectable({
  providedIn: 'root'
})
export class RoundOfQuestionsService {

  constructor(private http: HttpClient) { }

  static buildSearchParams(search: RoundOfQuestionsSearch): string {
    let searchParams = '';
    if (search.year) {
      searchParams += `&year=${search.year}`;
    }
    if (search.name && search.name !== '') {
      searchParams += `&name=${search.name}`;
    }
    if (search.launched || search.launched === false) {
      searchParams += `&launched=${search.launched}`;
    }
    if (search.startLaunched && search.startLaunched !== '') {
      searchParams += `&startLaunched=${search.startLaunched}`;
    }
    if (search.endLaunched && search.endLaunched !== '') {
      searchParams += `&endLaunched=${search.endLaunched}`;
    }
    if (search.status && search.status !== '') {
      searchParams += `&status=${search.status}`;
    }
    return searchParams;
  }

  getAll(search: RoundOfQuestionsSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<RoundOfQuestions>> {
    let url = `${ROUND_OF_QUESTIONS_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = RoundOfQuestionsService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<RoundOfQuestions>>(url + searchParams);
  }

  getAllDetail(id?: number, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<RoundOfQuestionsDetail>> {
    let url = `${ROUND_OF_QUESTIONS_API}/detail?size=${pageRequest.size}&page=${pageRequest.page}`;
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    if (id) {
      url = url + '&id=' + id;
    }
    return this.http.get<Page<RoundOfQuestionsDetail>>(url);
  }

  createRoundOfQuestions(dto: RoundOfQuestions, dtoDetail: RoundOfQuestionsDetail[]): Observable<ApiHttpResponse<RoundOfQuestions>> {
    return this.http.post<ApiHttpResponse<RoundOfQuestions>>(
      `${ROUND_OF_QUESTIONS_API}`,
      {roundOfQuestionsDto: dto, roundOfQuestionsDetailDto: dtoDetail} )
        .pipe(
          catchError(err => {
            return throwError(err);
          }),
          map((res: ApiHttpResponse<RoundOfQuestions>) => {
            return res;
          })
        );
  }

  editRoundOfQuestions(dto: RoundOfQuestions, dtoDetail: RoundOfQuestionsDetail[]): Observable<ApiHttpResponse<RoundOfQuestions>> {
    return this.http.put<ApiHttpResponse<RoundOfQuestions>>(
      `${ROUND_OF_QUESTIONS_API}`,
      {roundOfQuestionsDto: dto, roundOfQuestionsDetailDto: dtoDetail} )
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<RoundOfQuestions>) => {
          return res;
        })
      );
  }

  notifyRoundOfQuestions(dto: RoundOfQuestions,
                         system: boolean = false,
                         country: boolean = false): Observable<ApiHttpResponse<RoundOfQuestions>> {
    return this.http.post<ApiHttpResponse<RoundOfQuestions>>(
      `${ROUND_OF_QUESTIONS_API}/notify?system=${system}&country=${country}`, dto)
        .pipe(
          catchError(err => {
            return throwError(err);
          }),
        );
  }

  updateRoundOfQuestions(id: number): Observable<ApiHttpResponse<RoundOfQuestions>> {
    return this.http.put<ApiHttpResponse<RoundOfQuestions>>(`${ROUND_OF_QUESTIONS_API}/update`, id)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<RoundOfQuestions>) => {
          return res;
        })
      );
  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
